import { render, staticRenderFns } from "./AvaliacaoInicio.vue?vue&type=template&id=28c585c6&scoped=true&"
import script from "./AvaliacaoInicio.vue?vue&type=script&lang=js&"
export * from "./AvaliacaoInicio.vue?vue&type=script&lang=js&"
import style0 from "./AvaliacaoInicio.vue?vue&type=style&index=0&id=28c585c6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28c585c6",
  null
  
)

export default component.exports